import type { ClassNameValue } from "cnfast";

import { twMerge as cnfastTwMerge } from "cnfast";

export default function twMerge(...classLists: ClassNameValue[]) {
  return cnfastTwMerge(...classLists);
}
